export const initZendeskWidget = (): void => {
  const script = document.createElement("script");
  script.id = "ze-snippet";
  script.src =
    "https://static.zdassets.com/ekr/snippet.js?key=16032911-b0b1-43e2-852e-a33badd79317";
  document.body.appendChild(script);
};
